import { LogEvents } from '../../../models/InterviewOnboardingModel';
import axiosInstance from '../../../utils/apiClient';

export const getAssessmentSetup = async (key: string) => {
  return axiosInstance.get(`/invitation/setup-assessment?access_key=${key}`);
};

export const sendTranscriptionForEvaluation = async (
  access_key: string,
  question_id: string,
  answer_script: string
) => {
  const url = `/invitation/video/submit?access_key=${access_key}`;
  return axiosInstance.post(url, {
    question_id,
    answer_script,
  });
};

export const markVideoAsSubmission = async (
  access_key: string,
  question_id: string
) => {
  const url = `/invitation/video/mark/submission?access_key=${access_key}&question_id=${question_id}`;
  return axiosInstance.post(url);
};
export const markTextualAsSubmission = async (
  access_key: string,
  question_id: string,
  answer: string
) => {
  const url = `/invitation/textual-question/submit?access_key=${access_key}&question_id=${question_id}`;
  return axiosInstance.post(url, { answer_text: answer });
};
export const markTextualAsSkip = async (
  access_key: string,
  question_id: string
) => {
  const url = `/invitation/textual-question/incomplete?access_key=${access_key}&question_id=${question_id}`;
  return axiosInstance.get(url);
};

export const markVideoQuestionAsUnAttempted = async (
  access_key: string,
  question_id: string
) => {
  const url = `/invitation/video/mark/incomplete?access_key=${access_key}&question_id=${question_id}`;
  return axiosInstance.get(url);
};

export const markRetake = async (access_key: string, question_id: string) => {
  const url = `/invitation/video/retake?access_key=${access_key}&question_id=${question_id}`;
  return axiosInstance.get(url);
};

export const markQuestionVisibleToUser = async (
  access_key: string,
  question_id: string
) => {
  const url = `invitation/video/show-question?access_key=${access_key}&question_id=${question_id}`;
  return axiosInstance.get(url);
};

export const loadQuestion = async (
  key: string,
  questionNo: number,
  codeId: number | undefined = undefined
) => {
  let url = `/invitation/questions?access_key=${key}&question_no=${questionNo}`;
  if (codeId) url += `&code_id=${codeId}`;
  return axiosInstance.get(url);
};
export const loadCodingQuestion = async (
  key: string,
  questionId: string = '',
  codeId: number | undefined = undefined
) => {
  let url = `/bot/coding-question?access_key=${key}`;
  if (questionId) url += `&question_id=${questionId}`;
  if (codeId) url += `&code_id=${codeId}`;
  return axiosInstance.get(url);
};

export const botHelperData = async (type: string = '', key: string) => {
  let url = `/bot/helperData/${type}?access_key=${key}`;
  return axiosInstance.get(url);
};

export const checkForNext = async (key: string) => {
  let url = `/bot/next?access_key=${key}`;
  return axiosInstance.get(url);
};

export const loadTryQuestion = async (
  interviewerId: string,
  questionId: string,
  codeId?: number | null
) => {
  const URL = `${
    process.env.REACT_APP_HH_API
  }/question-trial/${interviewerId}/${questionId}?code_id=${codeId ?? ''}`;
  const response = await axiosInstance.get(URL);
  return response.data;
};

export const submitCode = async (
  key: string,
  data: any,
  isAdaptive = false
) => {
  let url = `/${
    isAdaptive ? 'adaptive' : 'invitation'
  }/coding-answer?access_key=${key}`;
  return axiosInstance.post(url, data);
};

export const submitTryQuestionCodeWithToken = async (
  interviewerId: any,
  questionId: any,
  token: any
) => {
  const url = `${process.env.REACT_APP_HH_API}/question-trial/test-case/status/${interviewerId}/${questionId}`;
  return axiosInstance.post(url, token);
};

export const submitTryQuestionCode = async (
  data: any,
  interviewerID: any,
  questionId: any
) => {
  const url = `${process.env.REACT_APP_HH_API}/question-trial/execute/${interviewerID}/${questionId}`;
  return axiosInstance.post(url, data);
};

export const invitationConfirmation = async (key: string) => {
  return axiosInstance.post(`/invitation/confirmation?access_key=${key}`, {
    name: 'swapnil',
    email: 'test@hirehunch.com',
  });
};

export const getAssessmentStatus = async (key: string, isAdaptive = false) => {
  return axiosInstance.get(
    `/${
      isAdaptive ? 'adaptive' : 'invitation'
    }/assessment-status?access_key=${key}`
  );
};

export const submitAssessment = async (
  overallRating: number,
  overallComments: string,
  accessKey: string | undefined
) => {
  return axiosInstance.post(`/invitation/rating?access_key=${accessKey}`, {
    overall_rating: overallRating,
    overall_comment: overallComments,
  });
};

export const submitQuestionAnswer = async (
  key: string,
  question_id: string,
  option: string | null,
  time_taken: number
) => {
  return axiosInstance.post(`/invitation/answer?access_key=${key}`, {
    question_id,
    option,
    time_taken,
  });
};

export const assessmentSubmission = async (key: string, isAdaptive = false) => {
  return axiosInstance.get(
    `/${
      isAdaptive ? 'adaptive' : 'invitation'
    }/submit-assessment?access_key=${key}`
  );
};

export const botAssessmentSubmission = async (key: string) => {
  return axiosInstance.get(`/bot/submit-assessment?access_key=${key}`);
};

export const assessmentLog = async (
  key: string,
  event_name: LogEvents,
  additionalData?: Record<string, any>
) => {
  return axiosInstance.post(`/invitation/log?access_key=${key}`, {
    event_name,
    ...additionalData,
  });
};

export const getTestcaseStatus = async (
  question_id: string,
  key: string,
  isAdaptive = false,
  body: any,
  signal: any
) => {
  return axiosInstance.post(
    `/${
      isAdaptive ? 'adaptive' : 'invitation'
    }/test-case-status?question_id=${question_id}&access_key=${key}`,
    [...body],
    {
      signal,
    }
  );
};

export const getAdaptiveQuestion = async (
  key: string,
  questionNo: number,
  codeId: number | undefined = undefined
) => {
  let url = `/adaptive/questions?access_key=${key}&question_no=${questionNo}`;
  if (codeId) url += `&code_id=${codeId}`;
  return axiosInstance.get(url);
};

export const adaptiveAssessmentSetup = (key: string) => {
  let url = `/adaptive/setup-assessment?access_key=${key}`;
  return axiosInstance.get(url);
};

export const pollSetupApi = (key: string) => {
  let url = `/adaptive/setup-assessment/poll?access_key=${key}`;
  return axiosInstance.get(url);
};

export const sendAdaptiveAnswer = (
  key: string,
  question_id: string,
  option: string | null,
  time_taken: number,
  questionNo: number
) => {
  return axiosInstance.post(
    `/adaptive/answer?access_key=${key}&question_no=${questionNo}`,
    {
      question_id,
      option,
      time_taken,
    }
  );
};
